(() => {
  const isEnglish = () => (document.documentElement.lang || '').toLowerCase().startsWith('en');
  const setText = (selector, text) => {
    const el = document.querySelector(selector);
    if (el && text) el.textContent = text;
  };
  const setAllText = (selector, text) => {
    document.querySelectorAll(selector).forEach((el) => { el.textContent = text; });
  };
  const setAria = (selector, label) => {
    const el = document.querySelector(selector);
    if (el) el.setAttribute('aria-label', label);
  };

  function repairBrandMegaMenu() {
    const grid = document.querySelector('[data-pq-mega="brands"] .wstq-mega__grid--brands');
    if (!grid) return;
    const links = grid.querySelectorAll('a');
    if (links.length > 1) return;
    const brands = [
      ['Pattana', '/collections/pattana'],
      ['Marco Fu', '/collections/marco-fu'],
      ['Taom', '/collections/taom'],
      ['ZAN', '/collections/zan'],
      ['Triple Crown', '/collections/triple-crown'],
      ['Lion Carbon Fiber', '/collections/lion'],
      ['童易', '/collections/tong-yi']
    ];
    grid.replaceChildren(...brands.map(([name, href]) => {
      const a = document.createElement('a');
      a.href = href;
      a.textContent = name;
      return a;
    }));
  }

  function removeUnpublishedLinks() {
    document.querySelectorAll('a[href="/pages/returns"], a[href$="/pages/returns"]').forEach((link) => link.remove());
  }

  function translateHeader() {
    const utility = document.querySelectorAll('.wstq-utility-links a');
    if (utility[0]) utility[0].textContent = 'Help';
    if (utility[1]) utility[1].textContent = 'Join';
    if (utility[2]) utility[2].textContent = 'Sign in';
    setAria('.wstq-utility-links', 'Account and help');
    setAria('.wstq-logo', 'Project Q Home');
    setAria('.wstq-mobile-search', 'Search products');
    setAria('.wstq-wishlist-open', 'Open wishlist');
    setAria('.wstq-mobile-menu > summary', 'Open menu');
    setAria('[data-category-rail]', 'Product category shortcuts');
    setAria('[data-category-next]', 'Next product category');
    const search = document.querySelector('.wstq-search-form input[type="search"]');
    if (search) search.placeholder = 'Search';
    const searchLabel = document.querySelector('.wstq-search-form label');
    if (searchLabel) searchLabel.textContent = 'Search products';

    document.querySelectorAll('.wstq-mobile-menu__link').forEach((link) => {
      const href = link.getAttribute('href') || '';
      if (href === '/' || href.endsWith('/')) link.textContent = 'Home';
      else if (href.includes('/pages/contact')) link.textContent = 'Help';
      else if (href.includes('/project-q-membership')) link.textContent = 'Join';
      else if (href.includes('/account')) link.textContent = 'Sign in';
    });

    const railLabels = new Map([
      ['%E5%85%A8%E6%96%B0%E7%90%83%E6%A1%BF', 'New Cues'],
      ['%E4%BA%8C%E6%89%8B%E5%AF%84%E8%B3%A3%E7%90%83%E6%A1%BF', 'Pre-owned Cues'],
      ['/chalk', 'Chalk'], ['/cue-tips', 'Cue Tips'], ['/cue-cases', 'Cue Cases'], ['/cue-care', 'Cue Care']
    ]);
    document.querySelectorAll('[data-category-rail] a').forEach((a) => {
      for (const [part, label] of railLabels) if ((a.href || '').includes(part)) a.textContent = label;
    });

    setText('#WishlistTitle', 'Wishlist');
    setText('.pq-wishlist-empty', 'Your wishlist is empty.');
  }

  function translateHome() {
    setText('.pqv2-categories__head h2', 'Shop by Category');
    document.querySelectorAll('.pqv2-category').forEach((card) => {
      const href = card.getAttribute('href') || '';
      const h = card.querySelector('h3');
      const p = card.querySelector('.pqv2-category__copy p');
      if (p) p.textContent = 'View products →';
      if (!h) return;
      if (href.includes('球桿-snooker') || href.includes('%E7%90%83%E6%A1%BF-snooker')) h.textContent = 'Snooker Cues';
      else if (href.includes('/cue-tips')) h.textContent = 'Cue Tips';
      else if (href.includes('/chalk')) h.textContent = 'Chalk';
      else if (href.includes('/cue-cases')) h.textContent = 'Cue Cases';
      else if (href.includes('/cue-care')) h.textContent = 'Cue Care';
    });
    setText('.pqv2-brands__head h2', 'Brands');
    setText('.pqv2-brands__head > a', 'View all collections');
    setText('.pqv2-merch__head h2', 'Selected Cues');
    setText('.pqv2-merch__head > a', 'View all cues');
    setText('.pqv2-preowned__head h2', 'Pre-owned & Consignment Cues');
    setText('.pqv2-preowned__shop', 'View all pre-owned cues');
    setText('.pqv2-preowned__wa', 'WhatsApp enquiry / Book a trial');
    const heroSecondary = document.querySelector('.pqv2-hero__secondary');
    if (heroSecondary) heroSecondary.textContent = 'Pre-owned / Consignment';
    const heroIntro = document.querySelector('.pqv2-hero__content > .rte');
    if (heroIntro) heroIntro.innerHTML = '<p>Specialist snooker equipment in Hong Kong. Book a cue trial, or order cue tips, chalk and accessories online.</p>';
  }

  function translateProduct() {
    const crumbs = document.querySelectorAll('.pqv2-pdp__crumbs a');
    if (crumbs[0]) crumbs[0].textContent = 'Home';
    if (crumbs[1]) crumbs[1].textContent = 'Shop';
    setText('.pqv2-summary__specbox h2', 'Cue Specifications');
    const labels = document.querySelectorAll('.pqv2-form > label');
    if (labels[0] && document.querySelector('[data-pqv2-variant]')) labels[0].textContent = 'Select option';
    if (labels.length) labels[labels.length - 1].textContent = 'Quantity';
    const root = document.querySelector('[data-pqv2-pdp]');
    if (root) {
      root.dataset.addLabel = 'Add to cart';
      root.dataset.soldLabel = 'Sold out';
    }
    const add = document.querySelector('[data-pqv2-add]');
    if (add && !add.disabled) add.textContent = 'Add to cart';
    else if (add) add.textContent = 'Sold out';
    document.querySelectorAll('.pqv2-form__actions a').forEach((a) => {
      if (a.textContent.includes('WhatsApp')) a.textContent = a.closest('.pqv2-form__actions--cue') ? 'WhatsApp enquiry / Book a trial' : 'WhatsApp enquiry';
    });
    const details = document.querySelectorAll('.pqv2-details summary');
    if (details[0]) details[0].textContent = 'Product details';
    if (details[1]) details[1].textContent = 'Delivery / Pickup';
    const delivery = document.querySelectorAll('.pqv2-details p');
    if (delivery.length) delivery[delivery.length - 1].textContent = 'Online stock is for reference. Please confirm availability and timing before visiting for a cue trial or pickup.';
    document.querySelectorAll('.pqv2-gallery__open span').forEach((span) => { span.textContent = 'Tap to zoom'; });
    const zoomHint = document.querySelector('.pqv2-zoom > p');
    if (zoomHint) zoomHint.textContent = 'Pinch to zoom; tap image to toggle zoom.';
  }

  function translateCollection() {
    setText('.pqv2-filter > summary', 'FILTERS');
    setText('.pqv2-filter button[type="submit"]', 'Apply');
    setText('.pqv2-filter form > a', 'Clear all');
    setText('.pqv2-sort label', 'SORT');
    setText('.pqv2-collection__empty', 'No products in this collection yet.');
  }

  function translateCart() {
    const crumbs = document.querySelectorAll('.pq-main--cart .pq-breadcrumbs *');
    if (crumbs[0]) crumbs[0].textContent = 'Home';
    if (crumbs[2]) crumbs[2].textContent = 'Cart';
    setText('.pq-cart-heading h1', 'Cart');
    const count = document.querySelector('.pq-cart-heading > span');
    if (count) count.textContent = count.textContent.replace('件產品', 'items');
    document.querySelectorAll('.pq-cart-item__controls label').forEach((x) => x.textContent = 'Quantity');
    document.querySelectorAll('.pq-cart-item__controls a').forEach((x) => x.textContent = 'Remove');
    setText('.pq-cart-items > button[name="update"]', 'Update cart');
    setText('.pq-cart-summary h2', 'Order summary');
    const summaryLabels = document.querySelectorAll('.pq-cart-summary > div span');
    if (summaryLabels[0]) summaryLabels[0].textContent = 'Subtotal';
    setText('.pq-cart-summary > p', 'Delivery, pickup and final stock availability are confirmed at order processing.');
    setText('.pq-cart-summary button[name="checkout"]', 'Checkout');
    setText('.pq-cart-summary .pq-button--ghost', 'Confirm on WhatsApp first');
    setText('.pq-contact-fallback', 'WhatsApp not opening? Use the contact form');
    setText('.pq-empty--large strong', 'Your cart is empty');
    setText('.pq-empty--large p', 'Start with cue tips, chalk, cue cases or cue-care products.');
    setText('.pq-empty--large .pq-button', 'View all products');
  }

  function translateFooter() {
    const headings = document.querySelectorAll('.wstq-footer__column h3');
    if (headings[0]) headings[0].textContent = 'Shop';
    if (headings[1]) headings[1].textContent = 'Customer Service';
    if (headings[2]) headings[2].textContent = 'Project Q';
    if (headings[3]) headings[3].textContent = 'Account';
    const newsletter = document.querySelector('.wstq-footer__brand > div');
    if (newsletter) newsletter.innerHTML = '<p>Subscribe for new arrivals, limited stock and Project Q updates.</p>';
    const email = document.querySelector('.wstq-newsletter-form input[type="email"]');
    if (email) email.placeholder = 'Email address';
    setText('.wstq-newsletter-form button', 'Subscribe');
    document.querySelectorAll('.wstq-footer a').forEach((a) => {
      const href = a.getAttribute('href') || '';
      if (href.includes('/delivery-pickup')) a.textContent = 'Delivery / Pickup';
      else if (href.includes('/stock-price-notice')) a.textContent = 'Stock & Price Notice';
      else if (href.includes('/privacy-policy')) a.textContent = 'Privacy Policy';
      else if (href.includes('/pages/contact')) a.textContent = 'Contact';
      else if (href.includes('/project-q-membership')) a.textContent = 'Project Q Membership';
      else if (href.includes('/account') && !href.includes('/orders')) a.textContent = 'My Account';
      else if (href.includes('/account/orders')) a.textContent = 'Orders';
      else if (href.endsWith('/cart') || href.includes('/cart?')) a.textContent = 'Cart';
      else if (href.includes('/search')) a.textContent = 'Search';
    });
  }

  function refreshCartBadge() {
    const badge = document.querySelector('.wstq-cart-count');
    if (!badge) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then((r) => r.ok ? r.json() : null)
      .then((cart) => {
        if (!cart || typeof cart.item_count !== 'number') return;
        badge.textContent = cart.item_count > 99 ? '99+' : String(cart.item_count);
        badge.hidden = cart.item_count === 0;
        const cartLink = document.querySelector('.wstq-cart-link');
        if (cartLink) cartLink.setAttribute('aria-label', isEnglish() ? `Cart, ${cart.item_count} items` : `購物車，共 ${cart.item_count} 件產品`);
      })
      .catch(() => {});
  }

  function init() {
    repairBrandMegaMenu();
    removeUnpublishedLinks();
    refreshCartBadge();
    if (!isEnglish()) return;
    translateHeader();
    translateHome();
    translateProduct();
    translateCollection();
    translateCart();
    translateFooter();
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('pageshow', refreshCartBadge);
  document.addEventListener('cart:updated', refreshCartBadge);
  document.addEventListener('cart:refresh', refreshCartBadge);
})();

(() => {
  const applyV4Copy = () => {
    const heroPrimary = document.querySelector('.pqv2-hero__primary');
    if (heroPrimary) {
      heroPrimary.textContent = '選購全新球桿';
      heroPrimary.href = '/collections/%E5%85%A8%E6%96%B0%E7%90%83%E6%A1%BF';
    }

    const brandsLink = document.querySelector('.pqv2-brands__head a');
    if (brandsLink) brandsLink.textContent = '查看全部品牌';

    const categoryCue = document.querySelector('.pqv2-category:first-child img');
    const featuredCue = document.querySelector('.pqv2-card__image');
    if (categoryCue && featuredCue) {
      categoryCue.src = featuredCue.src;
      categoryCue.srcset = featuredCue.srcset;
      categoryCue.sizes = '(max-width: 749px) 100vw, 58vw';
      categoryCue.alt = '精選英式桌球桿';
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyV4Copy, { once: true });
  } else {
    applyV4Copy();
  }
})();

(() => {
  const ready = (fn) => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  };

  ready(() => {
    document.addEventListener("click", (event) => {
      const summary = event.target.closest(".wstq-mega > summary");
      if (!summary) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const details = summary.closest("details");
      const nextOpen = !details.open;
      document.querySelectorAll(".wstq-mega[open]").forEach((item) => {
        if (item !== details) item.open = false;
      });
      details.open = nextOpen;
      window.setTimeout(() => {
        details.open = nextOpen;
      }, 0);
    }, true);

    document.addEventListener("click", (event) => {
      if (!event.target.closest(".wstq-mega")) {
        document.querySelectorAll(".wstq-mega[open]").forEach((item) => {
          item.open = false;
        });
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      document.querySelectorAll(".wstq-mega[open], .wstq-mobile-menu[open]").forEach((item) => {
        item.open = false;
      });
    });

    const mobileMenu = document.querySelector(".wstq-mobile-menu");
    if (mobileMenu) {
      mobileMenu.addEventListener("toggle", () => {
        const summary = mobileMenu.querySelector(":scope > summary");
        if (summary) {
          summary.setAttribute("aria-expanded", mobileMenu.open ? "true" : "false");
          summary.setAttribute("aria-label", mobileMenu.open ? "關閉選單" : "開啟選單");
        }
      });
    }

    const emptyCart = document.querySelector(".pq-empty--large");
    if (emptyCart && !emptyCart.querySelector(".pq-empty__quick-links")) {
      const links = document.createElement("nav");
      links.className = "pq-empty__quick-links";
      links.setAttribute("aria-label", "熱門產品分類");
      [
        ["全新球桿", "/collections/%E5%85%A8%E6%96%B0%E7%90%83%E6%A1%BF"],
        ["皮頭", "/collections/cue-tips"],
        ["Chalk 粉", "/collections/chalk"]
      ].forEach(([label, href]) => {
        const anchor = document.createElement("a");
        anchor.href = href;
        anchor.textContent = label;
        links.appendChild(anchor);
      });
      emptyCart.appendChild(links);
    }
  });
})();

